export default __webpack_public_path__ + "static/media/ModernLogo.1f39c75d.png";